import { render, staticRenderFns } from "./FlipCard.vue?vue&type=template&id=5c1f8ace&scoped=true"
import script from "./FlipCard.vue?vue&type=script&lang=js"
export * from "./FlipCard.vue?vue&type=script&lang=js"
import style0 from "./FlipCard.vue?vue&type=style&index=0&id=5c1f8ace&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1f8ace",
  null
  
)

export default component.exports